import axios from "axios";
import { formatErr } from "./errors";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export default api;

export const formatAUD = (v) => {
  const n = Number(v || 0);
  return `$${n.toLocaleString("en-AU", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

// Re-exported so all existing imports (`import { formatErr } from "@/lib/api"`)
// keep working. Definition lives in ./errors.js so it can be unit tested
// without pulling axios into the Jest sandbox.
export { formatErr };

